import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";
import { router } from "../main";

import clients from "./clients";
import confirm_dialog from "./confirm_dialog";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    message: "",
    loading: false,
    snackbar: {},
    packageVersion: process.env.PACKAGE_VERSION || "0"
  },
  getters: {
    isLoggedin: state => {
      return state.user ? true : false;
    },
    getAppVersion: state => {
      return state.packageVersion;
    },
    getUser: state => {
      return state.user;
    },
    getMessage: state => {
      return state.message;
    },
    isAdmin: state => {
      if (state.user) {
        return state.user.admin;
      } else return false;
    },
    getPermissaoLocacaoRole: state => {
      if (!state.user) {
        return null;
      }

      return state.user.permissao_locacao_role;
    },
    getLoading: state => {
      return state.loading;
    },
    getSnackbar: state => state.snackbar
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = null;
    },
    setMessage(state, message) {
      state.message = message;
    },
    setLoading(state, payload) {
      state.loading = payload.loading;
    },
    sendMessage(state, payload) {
      state.snackbar = { ...payload, active: true };
    },
    error(state, text) {
      state.snackbar = { text, color: "red", active: true };
    },
    success(state, text) {
      state.snackbar = { text, color: "success", active: true };
    },
    warning(state, text) {
      state.snackbar = { text, color: "orange", active: true };
    },
    closeMessage(state) {
      state.snackbar.active = false;
    }
  },
  actions: {
    // A sessão é um cookie do Laravel (Sanctum): aqui fica só o usuário logado.
    login(context, { user }) {
      context.commit("setUser", user);
      return Promise.resolve();
    },
    logout(context) {
      // Encerra a sessão no servidor; sem sessão (ou já vencida) a resposta é ignorada.
      Vue.prototype.$http.post("/auth/logout").catch(() => {});

      context.commit("clearUser");
    },
    // Depois de recarregar a página o usuário vem da sessão (cookie), pelo /auth/me.
    checkSession(context) {
      if (context.getters.isLoggedin) {
        return Promise.resolve();
      }

      return Vue.prototype.$http
        .get("/auth/me")
        .then(r => {
          context.commit("setUser", r.data.user);
        })
        .catch(e => {
          const data = (e.response && e.response.data) || {};
          context.commit(
            "setMessage",
            data.code === "USER_BLOCKED" ? data.message : "Faça login para acessar o conteúdo"
          );
          context.commit("clearUser");
        });
    }
  },
  modules: {
    clients: clients,
    confirm_dialog: confirm_dialog
  }
});
